import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { ManagementReportAccountingService } from '@core/services/entities/management-report-accounting.service';
import { CreateManagementReportAccountingRequestDto } from '@domain/management-report-accounting/dtos/create-management-report-accounting.request.dto';
import { ListManagementReportAccountingRequestDto } from '@domain/management-report-accounting/dtos/list-management-report-accounting.request.dto';
import { ManagementReportAccountingResponseDto } from '@domain/management-report-accounting/dtos/management-report-accounting.response.dto';
import { UpdateManagementReportAccountingRequestDto } from '@domain/management-report-accounting/dtos/update-management-report-accounting.request.dto';
import { ValidateErpManagementReportAccountingResponseDto } from '@domain/management-report-accounting/dtos/validate-erp-management-report-accounting.response.dto';
import { ManagementReportAccountingRepository } from '@domain/management-report-accounting/repositories/management-report-accounting.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ManagementReportAccountingRepositoryService
  implements ManagementReportAccountingRepository
{
  constructor(
    private managementReportAccountingService: ManagementReportAccountingService,
  ) {}

  list(
    request: ListManagementReportAccountingRequestDto,
  ): Observable<
    ApiResponse<PageableResponse<ManagementReportAccountingResponseDto>>
  > {
    return this.managementReportAccountingService.list(request);
  }

  show(
    request: RefId,
  ): Observable<ApiResponse<ManagementReportAccountingResponseDto>> {
    return this.managementReportAccountingService.show(request);
  }

  create(
    request: CreateManagementReportAccountingRequestDto,
  ): Observable<ApiResponse<ManagementReportAccountingResponseDto>> {
    return this.managementReportAccountingService.create(request);
  }

  update(
    request: UpdateManagementReportAccountingRequestDto,
  ): Observable<ApiResponse<ManagementReportAccountingResponseDto>> {
    return this.managementReportAccountingService.update(request);
  }

  delete(request: RefId): Observable<ApiResponse<void>> {
    return this.managementReportAccountingService.delete(request);
  }

  validateErp(
    request: RefId,
  ): Observable<ApiResponse<ValidateErpManagementReportAccountingResponseDto>> {
    return this.managementReportAccountingService.validateErp(request);
  }
}
